import React from "react";
import FunnelInsightCard from "./FunnelInsightCard";
import { buildCustomerAcquisitionChart } from "./funnelChartUtils";
import {
  cleanLines,
  extractTitle,
  stripTitleLines,
  extractTableBlock,
  splitByHeading,
  toBullets,
  toParagraphs,
  extractVerdict,
} from "./funnelUtils";

const FunnelCacPayback = ({ markdown = "" }) => {
  const title = extractTitle(markdown) || "CAC Payback";
  const lines = stripTitleLines(cleanLines(markdown));
  const { table, before, after } = extractTableBlock(lines);
  const chart = buildCustomerAcquisitionChart(table);
  const { tail } = splitByHeading(after, "What Does This Mean?");
  const bullets = toBullets(tail);
  let paragraphs = toParagraphs(tail);
  const verdict = extractVerdict(paragraphs);
  if (verdict) paragraphs = paragraphs.slice(0, -1);

  return (
    <FunnelInsightCard
      title={title}
      kicker="Acquisition Efficiency"
      sections={[
        {
          title: "CAC vs AOV",
          chart,
          chartTitle: "Mixed Signal View",
          chartSubtitle:
            "Bars show absolute metrics while the line surfaces percent based pressure.",
          table,
          paragraphs: before.length ? toParagraphs(before) : [],
        },
        {
          title: "What Does This Mean?",
          bullets,
          paragraphs,
          verdict,
        },
      ]}
    />
  );
};

export default FunnelCacPayback;
